const numberRegex = /^\d+$/;

// Existing paginated routes allow omitted pages and leading zeros.
export const validatePageNumber = (pageNumber?: string | number | null): boolean => {
  if (pageNumber) return numberRegex.test(String(pageNumber)) && parseInt(String(pageNumber)) > 0;
  return true;
};

// Required URL/query parameters must be canonical positive safe integers.
export const parsePositiveInteger = (value: unknown): number | null => {
  if (typeof value !== 'string' || !validatePageNumber(value)) return null;
  const number = Number(value);
  return Number.isSafeInteger(number) && number > 0 && String(number) === value ? number : null;
};
